import React from "react";
import { Card, Form, Button, Alert } from "react-bootstrap";

export default function XbrlProcessorView({
  entryPointPath,
  setEntryPointPath,
  isIngesting,
  ingestResult,
  ingestError,
  syncStatus,
  onIngestTaxonomy
}) {
  const synced = !!(ingestResult && ingestResult.headerId);
  const hierarchyMissing = synced && !ingestResult.hasHierarchy;
  const hasUnresolved = synced && ingestResult.unresolvedArcCount > 0;
  return (
    <div className="d-flex flex-column align-items-center">
      <div style={{ width: "100%", maxWidth: "650px" }} className="mb-4">

        {/* Ingest Taxonomy */}
        <Card className="border-0 shadow-sm" style={{ borderRadius: "12px" }}>
          <Card.Body className="p-4">
            <h2 className="h5 fw-bold mb-2">Ingest an XBRL Taxonomy</h2>
            <p className="small text-muted mb-4">
              This reads an official XBRL taxonomy package (for example, the EFRAG ESRS
              taxonomy) and builds the catalogue of reportable concepts that Sustina uses
              to define templates. You only need to do this once per taxonomy version, or
              when a new version is published.
            </p>

            <Form onSubmit={(e) => { e.preventDefault(); onIngestTaxonomy(); }}>
              <Form.Group className="mb-3">
                <Form.Label className="small fw-bold">Taxonomy entry point URL</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="e.g. https://xbrl.efrag.org/taxonomy/esrs/2023-12-22/esrs_all.xsd"
                  value={entryPointPath}
                  onChange={(e) => setEntryPointPath(e.target.value)}
                />
                <Form.Text className="text-muted">
                  The full web address of the taxonomy's main entry-point file, as published
                  by the standards body (usually ends in .xsd). Last known good URL:{" "}
                  <code>https://xbrl.efrag.org/taxonomy/esrs/2023-12-22/esrs_all.xsd</code>
                </Form.Text>
              </Form.Group>

              <Button
                type="submit"
                disabled={isIngesting || !entryPointPath.trim()}
                className="w-100"
              >
                {isIngesting ? <span className="spinner-border spinner-border-sm"></span> : "Ingest Taxonomy"}
              </Button>
              {isIngesting && syncStatus && (
                <div className="small text-muted mt-2 text-center">{syncStatus}</div>
              )}

              {ingestError && (
                <Alert variant="danger" className="py-2 small mt-3 mb-0">{ingestError}</Alert>
              )}
              {hierarchyMissing && (
                <Alert variant="warning" className="py-2 small mt-3 mb-0">
                  Concepts were saved, but the catalogue carried no hierarchy (no
                  disclosure tables or relationships). The XBRL processor may be
                  running an older version.
                </Alert>
              )}
              {hasUnresolved && (
                <Alert variant="warning" className="py-2 small mt-3 mb-0">
                  {ingestResult.unresolvedArcCount} relationship(s) could not be linked
                  to a saved concept or table.
                </Alert>
              )}
              {ingestResult && (
                <Alert variant="success" className="py-2 small mt-3 mb-0">
                  {synced ? (
                    <>
                      Taxonomy saved: <strong>{ingestResult.syncedConceptCount}</strong> concepts,{" "}
                      <strong>{ingestResult.syncedRoleCount ?? 0}</strong> disclosure tables,{" "}
                      <strong>{ingestResult.syncedArcCount ?? 0}</strong> hierarchy relationships.
                    </>
                  ) : (
                    "Taxonomy ingested. Saving to Sustina…"
                  )}
                  <pre className="bg-white border rounded p-2 mt-2 mb-0" style={{ maxHeight: "220px", overflow: "auto" }}>
                    {JSON.stringify(ingestResult, null, 2)}
                  </pre>
                </Alert>
              )}
            </Form>
          </Card.Body>
        </Card>

      </div>
    </div>
  );
}
